import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import GIS from '../views/GIS.vue'
import OpenInfo from '../views/OpenInfo.vue'
// import DataBuildForFishCatch from '../views/databases/DataBuildForFishCatch.vue'
// import Dashboard2 from '../views/Dashboard2.vue'
import Account from '../views/Account.vue'
import GroupInfo from '../views/GroupInfo.vue'
import DataBuildAdd from '../views/databases/DataBuildAdd.vue'
import MainDashboardForCrop from "../views/MainDashboardForCrop.vue";
// import DashboardForCrop from '../views/DashboardForCrop.vue'
import DashboardForFish from '../views/DashboardForFish.vue'
import DashboardForAnimal from '../views/DashboardForAnimal.vue'
import DashboardForRiceFarm from '../views/DashboardForRiceFarm.vue'
import DashboardCustomize from '../views/DashboardCustomize.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/GIS',
    name: 'GIS',
    component: GIS
  },
  {
    path: '/OpenInfo',
    name: 'OpenInfo',
    component: OpenInfo
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/linelogin',
    name: 'linelogin',
    component: () => import('../views/LineLogin.vue')
  },
  // {
  //   path: '/dashboard/:id',
  //   name: 'Dashboard',
  //   component: () => import('../views/Dashboard.vue')
  // },
  {
    path: '/databuild',
    name: 'DataBuild',
    component: () => import('../views/databases/DataBuild.vue')
  },
  {
    path: '/databuildadd/:id',
    name: 'DataBuildAdd',
    component: DataBuildAdd
  },
  {
    path: '/databuildforanimal',
    name: 'DataBuildForAnimal',
    component: () => import('../views/databases/DataBuildForAnimal.vue')
  },
  {
    path: '/databuildaddforanimal/:id',
    name: 'DataBuildAddForAnimal',
    component: () => import('../views/databases/DataBuildAddForAnimal.vue')
  },
  {
    path: '/databuildforfishcatch',
    name: 'DataBuildForFishCatch',
    component: () => import('../views/databases/DataBuildForFishCatch.vue')
  },
  {
    path: '/databuildaddforfishcatch/:id',
    name: 'DataBuildAddForFishCatch',
    component: () => import('../views/databases/DataBuildAddForFishCatch.vue')
  },
  {
    path: '/databuildaddforfishcatchnew/:id',
    name: 'DataBuildAddForFishCatchNew',
    component: () => import('../views/databases/DataBuildAddForFishCatchNew.vue')
  },
  {
    path: '/databuildforricefarm',
    name: 'DataBuildForRiceFarm',
    component: () => import('../views/databases/DataBuildForRiceFarm.vue')
  },
  {
    path: '/databuildaddforricefarm/:id',
    name: 'DataBuildAddForRiceFarm',
    component: () => import('../views/databases/DataBuildAddForRiceFarm.vue')
  },
  {
    path: '/databuildforinsectpests',
    name: 'DataBuildForInsectPests',
    component: () => import('../views/databases/DataBuildForInsectPests.vue')
  },
  // {
  //   path: '/receivelog',
  //   name: 'ReceiveLog',
  //   component: () => import('../views/databases/ReceiveLog.vue')
  // },
  {
    path: '/maindashboardforcrop',
    name: 'MainDashboardForCrop',
    component: MainDashboardForCrop
  },
  {
    path: '/normaldashboard/:type',
    name: 'NormalDashboard',
    component: () => import('../views/NormalDashboard.vue')
  },
  {
    path: '/dashboardforfish',
    name: 'DashboardForFish',
    component: DashboardForFish
  },
  {
    path: '/dashboardForanimal',
    name: 'DashboardForAnimal',
    component: DashboardForAnimal
  },
  {
    path: '/dashboardforricefarm',
    name: 'DashboardForRiceFarm',
    component: DashboardForRiceFarm
  },
  {
    path: '/DashboardCustomize/:type',
    name: 'DashboardCustomize',
    component: DashboardCustomize
  },
  {
    path: '/account',
    name: 'Account',
    component: Account
  },
  {
    path: '/authority',
    name: 'Authority',
    component: () => import('../views/Authority.vue')
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('../views/Profile.vue')
  },
  {
    path: '/changepassword',
    name: 'ChangePassword',
    component: () => import('../views/ChangePassword.vue')
  },
  {
    path: '/SetPassword',
    name: 'SetPassword',
    component: () => import('../views/SetPassword.vue')
  },
  {
    path: '/accountbinding',
    name: 'accountbinding',
    component: () => import('../views/AccountBinding.vue')
  },
  {
    path: '/myprefecture',
    name: 'myprefecture',
    component: () => import('../views/MyPrefecture.vue')
  },
  {
    path: '/mytrade',
    name: 'mytrade',
    component: () => import('../views/MyTrade.vue')
  },
  {
    path: '/myarea',
    name: 'myarea',
    component: () => import('../views/MyArea.vue')
  },
  {
    path: '/getgift',
    name: 'getgift',
    component: () => import('../views/GetGift.vue')
  },
  {
    path: '/GroupInfo/:id',
    name: 'GroupInfo',
    component: GroupInfo
  },
  {
    path: '/certification',
    name: 'Certification',
    component: () => import('../views/Certification.vue')
  },
    {
    path: '/subscription',
    name: 'subscription',
    component: () => import('../views/Subscription.vue')
  },
  {
    path: '/databuildforfarmsearch',
    name: 'DataBuildForFarmSearch',
    component: () => import('../views/databases/DataBuildForFarmSearch.vue')
  },
  {
    path: '/databuildforfarmsearchcontent',
    name: 'DataBuildForFarmSearchContent',
    component: () => import('../views/databases/DataBuildForFarmSearchContent.vue')
  },
  {
    path: '/databuildforpestsdiseases',
    name: 'DataBuildForPestsDiseases',
    component: () => import('../views/databases/DataBuildForPestsDiseases.vue')
  },
  {
    path: '/chart',
    name: 'chart',
    component: () => import('../views/databases/chartTest.vue')
  },
  {
    path: '/SupervisorArea',
    name: 'SupervisorArea',
    component: () => import('../views/SupervisorArea.vue')
  },
  {
    path: '/SupervisorFishArea',
    name: 'SupervisorFishArea',
    component: () => import('../views/SupervisorFishArea.vue')
  },
  {
    path: '/SupervisorAnimalArea',
    name: 'SupervisorAnimalArea',
    component: () => import('../views/SupervisorAnimalArea.vue')
  },
  // {
  //   path: '/logintest',
  //   name: 'logintest',
  //   component: () => import('../views/LoginTest.vue')
  // },
]

const router = new VueRouter({
  //mode: 'history',
  //base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes
})

export default router
